import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DocumentSignPageUI from './DocumentSignPageUI'

class DocumentSignPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      addendumUpdateMode: false,
      addendumUploadMode: false,
      addendumErrorList: [],
      signedLoan: null,
      clearAgreementSignListMode: false,
    }
  }

  render() {
    return (
      <DocumentSignPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        onRefreshClick={this.onRefreshClick}
        signedLoan={this.state.signedLoan}
        //
        addendumUpdateMode={this.state.addendumUpdateMode}
        onAddendumUpdateClick={() => { this.setState({ addendumUpdateMode: true }) }}
        onAddendumUpdateCancelClick={() => { this.setState({ addendumUpdateMode: false }) }}
        //
        addendumUploadMode={this.state.addendumUploadMode}
        onAddendumUploadClick={() => { this.setState({ addendumUploadMode: true }) }}
        onAddendumUpload={this.onAddendumUpload}
        onCancelAddendumUpload={() => { this.setState({ addendumUploadMode: false }) }}
        addendumErrorList={this.state.errorList}
        //
        onClearAgreementSignListClick={() => { this.setState({ clearAgreementSignListMode: true }) }}
        onClearAgreementSignListCancel={() => { this.setState({ clearAgreementSignListMode: false }) }}
        clearAgreementSignListMode={this.state.clearAgreementSignListMode}
      />
    )
  }

  componentDidMount() {
    this.getLoan(this.props.context)
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.loanId !== prevProps.match.params.loanId) {
      this.getLoan(this.props.context)
    }
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
    this.getAccountLoans(context, response.loan.accountId)
  }

  getAccountLoans(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}/loans`,
      cacheKey: CacheKeys.AccountLoans(accountId),
      callback: this.getAccountLoansCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountLoansCallback = (response) => {
    let signedLoan
    for (let loan of response.loanList) {
      if (loan.agreementSignList) {
        for (let agr of loan.agreementSignList) {
          if (agr.directorSignList && agr.directorSignList.length)
            signedLoan = loan
        }
      }
    }
    this.setState({ errorList: response.errorList, signedLoan: signedLoan })
  }

  onAddendumUpload = () => {
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}/documents/addendum/pdf/validation`,
      this.onAddendumUploadCallback, {}
    )
  }

  onAddendumUploadCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      addendumErrorList: errorList,
    })

    this.onRefreshClick('noBusy')
  }

  onRefreshClick = (noBusy) => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
    }
    else {
      this.setState({
        loan: null,
        errorList: null,
      }, () => {
        this.getLoan(context)
      })
    }
  }
}

export default withRouter(DocumentSignPageSF)
